module.exports = __webpack_public_path__ + "as.e922b2df545875b20b8b.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/as.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/as.svg
// module chunks = styles